import React, { useState, createContext, useContext } from 'react';
import { Country, countries } from '../data/mockData';
interface AppContextType {
  selectedCountry: Country;
  setSelectedCountry: (country: Country) => void;
}
const AppContext = createContext<AppContextType | undefined>(undefined);
export function AppProvider({
  children
}: {
  children: ReactNode;
}) {
  // Default to Spain
  const [selectedCountry, setSelectedCountry] = useState<Country>(countries.find(c => c.id === 'es') ?? countries[0]);
  return <AppContext.Provider value={{
    selectedCountry,
    setSelectedCountry
  }} data-id="element-52">
      {children}
    </AppContext.Provider>;
}
export function useAppContext() {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
}